'use client';

import { AppChrome } from './app-chrome';

/**
 * Client-only shell for global toasts / offline UI. Historically a thin wrapper
 * to avoid a second `dynamic()` layer in `app/layout.tsx`. Since Session 47
 * `AppChrome` no longer uses `next/dynamic` at all (Sonner's Toaster moved to a
 * static import + `mounted` flag), so this indirection is now vestigial — kept
 * only so existing root-layout imports keep resolving. Safe to inline at any
 * future tidying pass.
 */
export function AppChromeLoader() {
  return <AppChrome />;
}
